import React from "react";

import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
// core components
import ContactForm from "./Sections/ContactForm";

import GridContainerHome from "components/Grid/GridContainerHome.jsx";
import GridItemHome from "components/Grid/GridItemHome.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
// sections for this page

import SectionJavascript from "./Sections/SectionJavascript";

import Card from "components/Card/Card.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

class LandingPage extends React.Component {
  render() {
    const { classes, history } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg5bw.jpg")}>
            <div className={classes.container}>
              <GridContainerHome>
                <GridItemHome xs={12} sm={12} md={6}>
                  <div className={classes.brand}>
                    <h1 className={classes.title}>Pixsells<br/>New Internet</h1>
                    <h3 className={classes.subtitle}>
                      React.js | Redux | Solidity Ethereum Apps
                    </h3>
                    <br/>
                    <h5 className={classes.textLeft}>
                      <strong>I'm available for remote work - if you would like to build something awesome together, 
                      <a href="mailto:jvandelft@pixsells.nl"> Email</a> me or fill in the form -> I'll contact you within 24h.</strong>
                    </h5>
                  </div>
                </GridItemHome>
                <GridItemHome xs={12} sm={12} md={6}>
                  <Card>
                    <ContactForm history={history} />
                  </Card>
                </GridItemHome>
              </GridContainerHome>
            </div>
        </Parallax>
        <SectionJavascript />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx